import { Link } from "react-router-dom";
import styles from "./TuleButton.module.scss";

const ArrowIcon = ({ color, size = 30 }: { color: string; size: number }) => (
  <svg
    width={size}
    viewBox="0 0 26 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7071 8.70711C26.0976 8.31658 26.0976 7.68342 25.7071 7.2929L19.3431 0.928934C18.9526 0.538409 18.3195 0.538409 17.9289 0.928934C17.5384 1.31946 17.5384 1.95262 17.9289 2.34315L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.70711ZM-8.74228e-08 9L25 9L25 7L8.74228e-08 7L-8.74228e-08 9Z"
      fill={color}
    />
  </svg>
);

export interface TuleButtonProps {
  label?: string;
  onClick: () => void;
  withArrow?: boolean;
  to?: string;
  color?: {
    text?: string;
    background?: string;
    border?: string;
  };
  size?: {
    width?: string;
    height?: string;
  };
  ImageRender?: () => JSX.Element
}

/**
 * Tule Button
 *
 * @param param0
 * @returns
 */
export default function TuleButton({
  label,
  onClick,
  withArrow,
  to,
  color,
  size,
  ImageRender
}: TuleButtonProps) {
  const Content = () => {
    const stylesDynamic = {
      width: size?.width,
      height: size?.height,
      backgroundColor: color?.background,
      color: color?.text,
      borderColor: color?.border,
    };
    return (
      <div style={stylesDynamic} className={styles["tule-btn-container"]}>
        {
          ImageRender && <div className={styles["tule-btn-container__image"]}><ImageRender /></div>
        }
        <span className={styles["tule-btn-container__label"]}>{label}</span>
        <div className={styles["tule-btn-container__icon"]}>
          <ArrowIcon color={color?.text || "white"} size={30} />
        </div>
      </div>
    );
  };

  if (to) {
    return (
      <Link to={to} className={styles["tule-btn"]}>
        <Content />
      </Link>
    );
  }

  return (
    <button className={styles["tule-btn"]} onClick={onClick}>
      <Content />
    </button>
  );
}
